import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eth',
  templateUrl: './eth.component.html',
  styleUrls: ['./eth.component.scss']
})
export class EthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
